import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import { Button } from 'react-bootstrap';
import PastRoleForm from './PastRoleForm';
import { orderByStartDate } from '../../../arrayUtils';
import './PastRolesQuestion.scss';
var months = [{
  label: 'January',
  value: '0'
}, {
  label: 'February',
  value: '1'
}, {
  label: 'March',
  value: '2'
}, {
  label: 'April',
  value: '3'
}, {
  label: 'May',
  value: '4'
}, {
  label: 'June',
  value: '5'
}, {
  label: 'July',
  value: '6'
}, {
  label: 'August',
  value: '7'
}, {
  label: 'September',
  value: '8'
}, {
  label: 'October',
  value: '9'
}, {
  label: 'November',
  value: '10'
}, {
  label: 'December',
  value: '11'
}];
var initializedPastRole = function initializedPastRole() {
  return {
    title: '',
    role: '',
    companyName: '',
    description: '',
    startDateMonth: null,
    startDateYear: null,
    endDateMonth: null,
    endDateYear: null,
    current: false
  };
};
var pastRoleIndex = function pastRoleIndex(pastRoles, objectId) {
  return objectId ? pastRoles.findIndex(function (pastRole) {
    return pastRole.id === objectId;
  }) : pastRoles.findIndex(function (pastRole) {
    return !Object.hasOwn(pastRole, 'id');
  });
};
var editablePastRoles = function editablePastRoles(pastRoles) {
  return orderByStartDate(pastRoles).map(function (pastRole) {
    var pr = {
      id: pastRole.id,
      title: pastRole.title,
      role: pastRole.role,
      companyName: pastRole.company_name,
      description: pastRole.description,
      current: pastRole.current,
      is_suggested: pastRole.is_suggested
    };
    if (pastRole.start_date) {
      var startDateArray = pastRole.start_date.split('-').map(function (x) {
        return Number(x);
      });
      // Subtracted 1 to get the correct month
      var startDate = new Date(startDateArray[0], startDateArray[1] - 1, startDateArray[2]);
      pr.startDateMonth = months[startDate.getMonth()];
      var startYear = startDate.toLocaleString('default', {
        year: 'numeric'
      });
      pr.startDateYear = {
        label: startYear,
        value: startYear
      };
    }
    if (pastRole.end_date) {
      var endDateArray = pastRole.end_date.split('-').map(function (x) {
        return Number(x);
      });
      var endDate = new Date(endDateArray[0], endDateArray[1] - 1, endDateArray[2]);
      pr.endDateMonth = months[endDate.getMonth()];
      var endYear = endDate.toLocaleString('default', {
        year: 'numeric'
      });
      pr.endDateYear = {
        label: endYear,
        value: endYear
      };
    }
    return pr;
  });
};
var submittablePastRoles = function submittablePastRoles(newPastRoles) {
  return newPastRoles.map(function (pastRole) {
    var submittableStartDate = null;
    var submittableEndDate = null;
    if (pastRole.startDateMonth && pastRole.startDateYear) {
      submittableStartDate = new Date(Date.UTC(pastRole.startDateYear.label, pastRole.startDateMonth.value)).toISOString();
    } else if (pastRole.startDateYear) {
      submittableStartDate = new Date("".concat(pastRole.startDateYear.label));
    }
    if (pastRole.endDateMonth && pastRole.endDateYear) {
      submittableEndDate = new Date(Date.UTC(pastRole.endDateYear.label, pastRole.endDateMonth.value)).toISOString();
    } else if (pastRole.endDateYear) {
      submittableEndDate = new Date("".concat(pastRole.endDateYear.label));
    }
    var pr = {
      id: pastRole === null || pastRole === void 0 ? void 0 : pastRole.id,
      title: pastRole.title,
      role: pastRole.role,
      company_name: pastRole.companyName,
      description: pastRole.description,
      start_date: submittableStartDate,
      current: pastRole.current,
      is_suggested: pastRole.is_suggested,
      is_edited: pastRole.is_edited || false,
      end_date: submittableEndDate
    };
    return pr;
  });
};
var setNewPastRoles = function setNewPastRoles(objectId, onboardingQuestionnaire, pastRoles, onProposalPage) {
  var newPastRoles = objectId || onboardingQuestionnaire ? editablePastRoles(pastRoles) : [].concat(_toConsumableArray(editablePastRoles(pastRoles)), [initializedPastRole()]);
  if (onProposalPage) {
    newPastRoles = [];
  }
  return newPastRoles;
};
var validatePastRole = function validatePastRole(pastRole) {
  // If it is a delete action return [] or Skip Validation for Saved Roles
  if (!pastRole || pastRole.id) return [];
  var error = [];
  if (!pastRole.title) error.push('title');
  if (!pastRole.companyName) error.push('company name');
  if (pastRole.startDateYear == null) error.push('start date');
  if (!pastRole.current) {
    if (pastRole.endDateYear == null) {
      error.push('end date');
    } else if (!error.includes('start date')) {
      var safeStartMonth = pastRole.startDateMonth ? pastRole.startDateMonth.value : null;
      var safeEndMonth = pastRole.endDateMonth ? pastRole.endDateMonth.value : null;
      var startDate = new Date(pastRole.startDateYear.value, safeStartMonth);
      var endDate = new Date(pastRole.endDateYear.value, safeEndMonth);
      if (startDate > endDate) {
        error.push('end date', 'The end date must be after the start date.');
      }
    }
  }
  return error;
};
var PastRolesQuestion = /*#__PURE__*/function (_Component) {
  function PastRolesQuestion(props) {
    var _this;
    _classCallCheck(this, PastRolesQuestion);
    _this = _callSuper(this, PastRolesQuestion, [props]);
    var objectId = props.objectId,
      onboardingQuestionnaire = props.onboardingQuestionnaire,
      newPastRoles = props.newPastRoles,
      onProposalPage = props.onProposalPage;
    _this.state = {
      errors: [],
      newPastRoles: setNewPastRoles(objectId, onboardingQuestionnaire, newPastRoles, onProposalPage)
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleDateChange = _this.handleDateChange.bind(_this);
    _this.handleDeletePastRole = _this.handleDeletePastRole.bind(_this);
    _this.handleSubmit = debounce(_this.handleSubmit.bind(_this), 500);
    return _this;
  }
  _inherits(PastRolesQuestion, _Component);
  return _createClass(PastRolesQuestion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Initially save the suggested past roles for onboarding because it is autofilled
      // and edits triggers saves
      if (this.props.saveOnChange && this.props.newPastRoles) {
        var _this$props = this.props,
          handleChange = _this$props.handleChange,
          questionKey = _this$props.questionKey;
        var newPastRoles = this.state.newPastRoles;
        handleChange(submittablePastRoles(newPastRoles), questionKey, null, false);
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(value, key, index) {
      var newPastRoles = this.state.newPastRoles;
      var saveOnChange = this.props.saveOnChange;
      newPastRoles[index][key] = value;
      newPastRoles[index].is_edited = true;
      this.setState({
        newPastRoles: newPastRoles
      });
      if (saveOnChange) {
        this.handleSubmit();
      }
    }
  }, {
    key: "handleDateChange",
    value: function handleDateChange(value, key, index) {
      var newPastRoles = this.state.newPastRoles;
      newPastRoles[index][key] = value;
      newPastRoles[index].is_edited = true;
      this.setState({
        newPastRoles: newPastRoles
      });
      var saveOnChange = this.props.saveOnChange;
      if (saveOnChange) {
        this.handleSubmit();
      }
    }
  }, {
    key: "handleDeletePastRole",
    value: function handleDeletePastRole(index) {
      var _this$state = this.state,
        newPastRoles = _this$state.newPastRoles,
        errors = _this$state.errors;
      var onProposalPage = this.props.onProposalPage;
      var initialLength = newPastRoles.length;
      newPastRoles.splice(index, 1);
      var newLength = newPastRoles.length;
      errors.splice(index, 1);
      this.setState({
        newPastRoles: newPastRoles,
        errors: errors
      });
      var saveOnChange = this.props.saveOnChange;
      if (saveOnChange || initialLength !== newLength) {
        this.handleSubmit(!onProposalPage);
      }
    }
  }, {
    key: "handleValidation",
    value: function handleValidation() {
      var objectId = this.props.objectId;
      var newPastRoles = this.state.newPastRoles;
      var modifiedIndex = pastRoleIndex(newPastRoles, objectId);
      var pastRole = newPastRoles[modifiedIndex];
      if (objectId) {
        return [validatePastRole(pastRole)];
      }
      var errors = newPastRoles.map(function (pr) {
        var error = validatePastRole(pr);
        return error;
      });
      return errors;
    }
  }, {
    key: "handleAddPastRole",
    value: function handleAddPastRole() {
      var newPastRoles = this.state.newPastRoles;
      newPastRoles.push(initializedPastRole());
      this.setState({
        newPastRoles: newPastRoles
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var shouldModalClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var newPastRoles = this.state.newPastRoles;
      var _this$props2 = this.props,
        onboardingQuestionnaire = _this$props2.onboardingQuestionnaire,
        profileQuestionnaire = _this$props2.profileQuestionnaire,
        handleChange = _this$props2.handleChange,
        questionKey = _this$props2.questionKey,
        closeModal = _this$props2.closeModal,
        isReadingMore = _this$props2.isReadingMore,
        handlePastRolesAfterUpdate = _this$props2.handlePastRolesAfterUpdate,
        onProposalPage = _this$props2.onProposalPage;
      var errors = this.handleValidation();
      if (errors.every(function (error) {
        return error.length === 0;
      })) {
        handleChange(submittablePastRoles(newPastRoles), questionKey, null, false).then(function (res) {
          if (res) {
            handlePastRolesAfterUpdate(res.data);
          }
        });

        // On onboarding, we do not re-insert an empty one
        var updatedState = onboardingQuestionnaire || onProposalPage ? {
          newPastRoles: newPastRoles,
          errors: []
        } : {
          newPastRoles: [].concat(_toConsumableArray(newPastRoles.filter(function (pr) {
            return pr.id;
          })), [initializedPastRole()])
        };
        this.setState(updatedState, function () {
          if (shouldModalClose) {
            closeModal();
          }
          if (profileQuestionnaire) {
            var currentPath = window.location.href;
            var noParamsPath = currentPath.substring(0, currentPath.indexOf('?'));
            window.history.pushState(null, 'Clora Consultant Profile', "".concat(noParamsPath, "?is_reading_more=").concat(isReadingMore));
          }
        });
      } else {
        this.setState({
          errors: errors
        });
      }
    }
  }, {
    key: "renderNewPastRoles",
    value: function renderNewPastRoles() {
      var _this2 = this;
      var _this$props3 = this.props,
        showBorder = _this$props3.showBorder,
        onboardingQuestionnaire = _this$props3.onboardingQuestionnaire,
        onProposalPage = _this$props3.onProposalPage,
        objectId = _this$props3.objectId;
      var _this$state2 = this.state,
        newPastRoles = _this$state2.newPastRoles,
        errors = _this$state2.errors;
      var modifiedIndex = pastRoleIndex(newPastRoles, objectId);
      var pastRole = newPastRoles[modifiedIndex];

      // On the Consultant Onboarding flow, we render one form per existing Past Role
      if (onboardingQuestionnaire || onProposalPage) {
        return /*#__PURE__*/React.createElement("form", {
          className: "new-past-roles ".concat(showBorder && 'border')
        }, newPastRoles.map(function (pr, index) {
          return /*#__PURE__*/React.createElement("div", {
            className: "new-past-role",
            key: pr === null || pr === void 0 ? void 0 : pr.id
          }, /*#__PURE__*/React.createElement("input", {
            type: "hidden",
            name: "is_suggested",
            value: pr.is_suggested
          }), /*#__PURE__*/React.createElement(PastRoleForm, {
            classNamePrefix: "profile-add-past-role",
            index: index,
            pastRole: pr,
            error: errors[index] || [],
            handleInputChange: _this2.handleInputChange,
            handleDateChange: _this2.handleDateChange,
            handleDeletePastRole: _this2.handleDeletePastRole,
            onboardingQuestionnaire: onboardingQuestionnaire,
            onProposalPage: onProposalPage
          }));
        }));
      }
      if (pastRole) {
        return /*#__PURE__*/React.createElement("form", {
          className: "new-past-roles ".concat(showBorder && 'border')
        }, /*#__PURE__*/React.createElement("div", {
          className: "new-past-role",
          key: pastRole === null || pastRole === void 0 ? void 0 : pastRole.id
        }, /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          name: "is_suggested",
          value: pastRole.is_suggested
        }), /*#__PURE__*/React.createElement(PastRoleForm, {
          classNamePrefix: "profile-add-past-role",
          index: modifiedIndex,
          pastRole: pastRole,
          error: errors[modifiedIndex],
          handleInputChange: this.handleInputChange,
          handleDateChange: this.handleDateChange,
          handleDeletePastRole: this.handleDeletePastRole,
          onboardingQuestionnaire: onboardingQuestionnaire,
          onProposalPage: onProposalPage
        })));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props4 = this.props,
        disableSubmit = _this$props4.disableSubmit,
        saveOnChange = _this$props4.saveOnChange,
        onboardingQuestionnaire = _this$props4.onboardingQuestionnaire,
        onProposalPage = _this$props4.onProposalPage;
      var newPastRoles = this.state.newPastRoles;
      return /*#__PURE__*/React.createElement(Fragment, null, newPastRoles.length > 0 && this.renderNewPastRoles(), /*#__PURE__*/React.createElement("div", {
        className: "footer"
      }, (onboardingQuestionnaire || onProposalPage) && /*#__PURE__*/React.createElement("a", {
        role: "link",
        tabIndex: 0,
        id: "add-past-role",
        onClick: function onClick() {
          return _this3.handleAddPastRole();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus me-3"
      }), "".concat(newPastRoles.length === 0 ? 'Add Role' : 'Add another role')), newPastRoles.length > 0 && !saveOnChange && /*#__PURE__*/React.createElement("div", {
        className: "buttons-bar text-center"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "primary",
        id: "update-proposal-past-roles",
        className: "save",
        onClick: this.handleSubmit,
        disabled: disableSubmit && newPastRoles.length === 0
      }, "Save"))));
    }
  }]);
}(Component);
PastRolesQuestion.propTypes = {
  newPastRoles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleChange: PropTypes.func.isRequired,
  questionKey: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  disableSubmit: PropTypes.bool,
  showBorder: PropTypes.bool,
  saveOnChange: PropTypes.bool,
  onboardingQuestionnaire: PropTypes.bool,
  profileQuestionnaire: PropTypes.bool,
  onProposalPage: PropTypes.bool,
  objectId: PropTypes.number,
  isReadingMore: PropTypes.bool,
  handlePastRolesAfterUpdate: PropTypes.func
};
PastRolesQuestion.defaultProps = {
  disableSubmit: true,
  showBorder: false,
  saveOnChange: false,
  onboardingQuestionnaire: false,
  profileQuestionnaire: false,
  onProposalPage: false,
  objectId: null,
  isReadingMore: false,
  handlePastRolesAfterUpdate: function handlePastRolesAfterUpdate() {}
};
export default PastRolesQuestion;